// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip--PFzZJ","highlight":"highlight--Nwnct"};